export default {"src":"/_next/static/media/info.ae732c2e.svg","height":48,"width":48};